import { Card, CardContent } from "@/components/ui/card";
import { Utensils, TreePine, Mountain } from "lucide-react";
import { LucideIcon } from "lucide-react";

interface GemCardProps {
  title: string;
  before: string;
  after: string;
  category: "food" | "lodging" | "adventure";
}

const categoryIcons: Record<string, LucideIcon> = {
  food: Utensils,
  lodging: TreePine,
  adventure: Mountain,
};

const categoryColors: Record<string, string> = {
  food: "text-orange-500",
  lodging: "text-green-600",
  adventure: "text-blue-600",
};

export const GemCard = ({ title, before, after, category }: GemCardProps) => {
  const Icon = categoryIcons[category];

  return (
    <Card className="cursor-pointer hover:shadow-lg transition-all duration-300 hover:scale-105">
      <CardContent className="p-4">
        <div className="aspect-square bg-gradient-to-br from-primary/5 to-secondary/5 rounded-lg mb-4 flex flex-col items-center justify-center p-6 text-center">
          <Icon className={`w-16 h-16 mb-4 ${categoryColors[category]}`} />
          <p className="text-gray-600 text-sm">
            <span className="font-semibold">Avant :</span> {before}
            <br />
            <span className="font-semibold">Après :</span> {after}
          </p>
        </div>
        <h3 className="font-mono font-bold text-lg text-center">{title}</h3>
      </CardContent>
    </Card>
  );
};